/* default_device.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" xml:space="preserve">
            <rect class="foreground-gl" width="19.8" height="19.8" rx="1.98" ry="1.98"/>
        </svg>
    `
};
